export const setPage = (page) => {
  return { type: 'SET_PAGE', payload: page };
};

export const setParams = (params) => {
  return { type: 'SET_PARAMS', payload: params };
};

export const setSlug = (slug) => {
  return { type: 'SET_SLUG', payload: slug };
};
